import GdprExplanationsController from "./gdprExplanationsController";
import "./gdprExplanations.scss";

const gdprExplanationsComponent = {
    template: require("./gdprExplanationsView.html"),
    controller: GdprExplanationsController,
};

export default gdprExplanationsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/gdprExplanations/gdprExplanationsComponent.js